export const API_VERSION = 'v1';
export const API_ERRORS = Object.freeze([
  'UNAUTHENTICATED','FORBIDDEN','NOT_FOUND','NOT_ENROLLED','VALIDATION_ERROR',
  'CONFLICT','RATE_LIMITED','SERVER_ERROR',
]);

export function createMajorHighApiV1(client) {
  const read = async (operation, ref = null) => {
    const { data, error } = await client.rpc('major_high_learner_api_v1', { p_operation: operation, p_ref: ref });
    if (error) throw Object.assign(new Error('SERVER_ERROR'), { code: 'SERVER_ERROR' });
    if (data?.error) throw Object.assign(new Error(data.error.code), { code: data.error.code });
    return data.data;
  };
  return {
    version: API_VERSION,
    me: () => read('ME'), enrollments: () => read('ENROLLMENTS'), courses: () => read('COURSES'),
    course: (ref) => read('COURSE', ref), modules: (courseRef) => read('MODULES', courseRef),
    lessons: (moduleRef) => read('LESSONS', moduleRef), lesson: (ref) => read('LESSON', ref),
    lessonProgress: (ref) => read('LESSON_PROGRESS', ref), progress: () => read('PROGRESS'),
    continueWatching: () => read('CONTINUE_WATCHING'), nextLearningAction: () => read('NEXT_LEARNING_ACTION'),
    materials: (lessonRef) => read('MATERIALS', lessonRef), captions: (lessonRef) => read('CAPTIONS', lessonRef),
    playback: (lessonRef) => read('PLAYBACK', lessonRef),
    saveLessonProgress: async (input) => {
      const { data, error } = await client.rpc('save_canonical_lesson_progress_v1', {
        p_progress_update_ref: input.progressUpdateRef, p_lesson_id: input.lessonRef,
        p_progress_percentage: input.percentage, p_last_position_seconds: input.positionSeconds,
        p_watched_seconds_delta: input.watchedSecondsDelta, p_client_type: input.clientType || 'UNKNOWN',
        p_session_ref: input.sessionRef || null,
      });
      if (error) {
        const code = API_ERRORS.find((value) => error.message?.includes(value)) || 'SERVER_ERROR';
        throw Object.assign(new Error(code), { code });
      }
      return Array.isArray(data) ? data[0] : data;
    },
  };
}
